import './Filter.scss';
import './JobActivityFilter.scss';
import Accordion from 'react-bootstrap/Accordion';
import Card from 'react-bootstrap/Card';
import { Error, Loading } from '../_common';
import React, { useState } from 'react';
import { useQuery } from '@apollo/client/react';
import { useStoreContext } from '../App/StoreProvider';
import {
    GET_ALL_LOFAS_BY_JOB,
    GET_ALL_CARRIERS_FILTER,
    GET_ALL_PROPPANTS_BY_JOB,
    GET_ALL_DRIVERS_FILTER,
} from '../../graphql/client/queries';
import {
    GetAllLofasByJob,
    GetAllDriversFilter,
    GetAllCarriersFilter,
    GetAllProppantsByJob,
} from '../../types/schemaTypes';
import LoadFilterItem from './FilterItem/LoadFilterItem';
import Button from 'react-bootstrap/Button';
import oilWellIcon from '../../assets/oilWell.png';
import lofaIcon from '../../assets/lofaIcon.png';
import whiteTruckIcon from '../../assets/whiteTruck.png';
import blueTruckIcon from '../../assets/blueTruck.png';
import tealTruckIcon from '../../assets/tealTruck.png';
import orangeTruckIcon from '../../assets/orangeTruck.png';
import greenTruckIcon from '../../assets/greenTruck.png';
import redTruckIcon from '../../assets/redTruck.png';

interface JobMapFiltersProps {
    abortRequest: () => void;
    jobId: number;
    onFilterToggle: () => void;
}

export const JobMapFilters = ({ abortRequest, jobId, onFilterToggle }: JobMapFiltersProps): React.ReactElement => {
    const [activeKey, setActiveKey] = useState('0');
    const [state] = useStoreContext();

    const lofaFilters: any = [];
    let carrierFilters: any = [];
    const proppants: any = [];
    let driverFilters: any[] = [];
    const statuses: any = [
        {
            id: 'Assigned',
            name: 'Assigned',
        },
        {
            id: 'Loading',
            name: 'Loading',
        },
        {
            id: 'Loaded',
            name: 'Loaded',
        },
        {
            id: 'On-site',
            name: 'On-site',
        },
    ];

    const variables = {
        jobId,
    };

    const {
        loadManagementList: {
            searchPhraseSubset: { lofaSubset, carrierSubset, proppantSubset, driverSubset, statusSubset },
        },
    } = state;

    const { data: proppantsData, loading: proppantLoading, error: proppantError } = useQuery<GetAllProppantsByJob>(GET_ALL_PROPPANTS_BY_JOB, {
        variables,
    });

    const { data: lofasData } = useQuery<GetAllLofasByJob>(GET_ALL_LOFAS_BY_JOB, { variables });
    const { data: carriersData } = useQuery<GetAllCarriersFilter>(GET_ALL_CARRIERS_FILTER);
    const { data: driversData } = useQuery<GetAllDriversFilter>(GET_ALL_DRIVERS_FILTER);

    if (proppantLoading) {
        return <Loading />;
    }
    if (proppantError) {
        return <Error error={proppantError} />;
    }

    if (lofasData && lofasData.getAllLofasByJob) {
        lofasData.getAllLofasByJob.forEach((item: any) => {
            lofaFilters.push({
                id: item.lofaId,
                name: item.lofaName,
            });
        });
    }

    if (driversData && driversData.getAllDriversFilter) {
        driverFilters = driversData.getAllDriversFilter;
    }

    if (carriersData && carriersData.getAllCarriersFilter) {
        carrierFilters = carriersData.getAllCarriersFilter;
    }

    if (proppantsData && proppantsData.getAllProppantsByJob) {
        proppantsData.getAllProppantsByJob.forEach((item: any) => {
            proppants.push({
                id: item.proppantId,
                name: item.proppantName,
            });
        });
    }

    return (
        <div className="Filter-Container">
            <div>
                <Accordion>
                    <Card className="FilterItem-Card">
                        <Card.Body>
                            <table className="table-bordered">
                                {/* <thead>
                                    <tr>
                                        <th className="MapLegend-Header">Map Legend</th>
                                    </tr>
                                </thead> */}
                                <tbody>
                                    <tr>
                                        <td className="col-3">Well Site: </td>
                                        <td className="col-3">
                                            <img src={oilWellIcon} />
                                        </td>
                                        <td className="col-3">LOFA: </td>
                                        <td className="col-3">
                                            <img src={lofaIcon} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="col-3">Assigned:</td>
                                        <td className="col-3">
                                            <img src={blueTruckIcon} />
                                        </td>
                                        <td className="col-3">Loading:</td>
                                        <td className="col-3">
                                            <img src={tealTruckIcon} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="col-3">Loaded:</td>
                                        <td className="col-3">
                                            <img src={orangeTruckIcon} />
                                        </td>
                                        <td className="col-3">On-Site:</td>
                                        <td className="col-3">
                                            <img src={greenTruckIcon} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="col-3">Checked In:</td>
                                        <td className="col-3">
                                            <img src={whiteTruckIcon} />
                                        </td>
                                        <td className="col-3">Late:</td>
                                        <td className="col-3">
                                            <img src={redTruckIcon} />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </Card.Body>
                    </Card>
                </Accordion>
            </div>
            <div className="Filter-Header">
                <div className="Filter-HeaderIconContainer">
                    <i className="material-icons">filter_list</i>
                    <span className="Filter-HeaderTitle">Filters</span>
                </div>
                <Button
                    className="Filter-SelectAll"
                    variant="link"
                    onClick={(): void => setActiveKey(activeKey === '0' ? '1' : '0')}
                >
                    {activeKey === '0' ? 'Collapse All' : 'Expand All'}
                </Button>
            </div>
            <LoadFilterItem
                abortRequest={abortRequest}
                title="Load Status"
                items={statuses}
                itemsSubset={statusSubset.subset}
                searchPhrase={statusSubset.searchPhrase}
                activeKey={activeKey}
                isCollection={true}
                isSearchable={false}
                loadManagementMode={true}
                onFilterToggle={onFilterToggle}
            />
            <LoadFilterItem
                abortRequest={abortRequest}
                title="Loading Facility"
                items={lofaFilters}
                itemsSubset={lofaSubset.subset}
                searchPhrase={lofaSubset.searchPhrase}
                activeKey={activeKey}
                isCollection={true}
                isSearchable={true}
                loadManagementMode={true}
                onFilterToggle={onFilterToggle}
            />
            <LoadFilterItem
                abortRequest={abortRequest}
                title="Proppant"
                items={proppants}
                itemsSubset={proppantSubset.subset}
                searchPhrase={proppantSubset.searchPhrase}
                activeKey={activeKey}
                isCollection={true}
                isSearchable={true}
                loadManagementMode={true}
                onFilterToggle={onFilterToggle}
            />
            <LoadFilterItem
                abortRequest={abortRequest}
                title="Driver"
                items={driverFilters}
                itemsSubset={driverSubset.subset}
                searchPhrase={driverSubset.searchPhrase}
                activeKey={activeKey}
                isCollection={true}
                isSearchable={true}
                loadManagementMode={true}
                onFilterToggle={onFilterToggle}
            />
            <LoadFilterItem
                abortRequest={abortRequest}
                title="Carrier"
                items={carrierFilters}
                itemsSubset={carrierSubset.subset}
                searchPhrase={carrierSubset.searchPhrase}
                activeKey={activeKey}
                isCollection={true}
                isSearchable={true}
                loadManagementMode={true}
                onFilterToggle={onFilterToggle}
            />
        </div>
    );
};
